import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";

export const hideOnDesktopView = css`
  ${MEDIA_QUERY_FOR_PC} {
    display: none;
  }
`;

export const infoWrapperStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const infoTitleTextStyle = css`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

export const infoDetailTextStyle = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const infoOptionalTextStyle = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #757575;
`;
